export const optionsSerie = [
    {id: 1, name: "Royal Chef 800"},
    {id: 2, name: "Rosichef Signature 900"},
    {id: 22, name: "Rosichef 900"}
]
